var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartImage = function SvgPartImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.047 14.398a1.74 1.74 0 0 1-.89-1.539v-7c0-.648.327-1.218.89-1.546L7.109.82a1.7 1.7 0 0 1 1.782 0l6.054 3.493c.563.328.89.898.89 1.546v7a1.74 1.74 0 0 1-.89 1.54l-6.054 3.507a1.73 1.73 0 0 1-1.782 0zM8 8.891l6.188-3.524c-.04-.039-.055-.062-.118-.101L8.453 2.023a.88.88 0 0 0-.914 0L1.93 5.266c-.07.039-.085.062-.124.101zm-.633 7.703v-6.586L1.414 6.625v6.008a.91.91 0 0 0 .461.789l5.367 3.101c.063.04.07.047.125.07m1.258 0c.078-.04.086-.047.172-.094l5.328-3.078a.9.9 0 0 0 .453-.79V6.626l-5.953 3.383z"
  })));
};
export default SvgPartImage;